module.exports = __webpack_public_path__ + "img/fundacion_paraguaya.cd68e064.png";